export default __webpack_public_path__ + "static/logo_svg_2018-769c0c809b90fe72e07d923ee82222e7.svg";